import { XHRClient } from './xhr-client';

type QueryData = { [value: string]: any };

export class BazisXHRClient extends XHRClient {
  private _userId = 0;

  constructor(userId: number) {
    super();
    this._userId = userId;
  }

  protected setHeaders(): void {
    this.xhr.setRequestHeader('User-ID', this._userId.toString());
  }
}
